import { useEffect, useState, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate } from 'lib/formatter.ts';
import TopNav from 'components/topNav.jsx';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import CommonFns from 'functions/common.ts';
import DialogEditRequisiton from 'components/dialogEditRequisition';
import Http from 'services/http2';
import ModalService from 'services/modal';
import { ActionContext } from 'actions/context';
import User from 'services/user2';

/* dev
https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fpurchase%2Frequisition%2Flist&response_type=code&scope=snsapi_base&state=123#wechat_redirect
*/
function RequisitionList(props) {
  const Config = {
    purchase: {
      title: '请购单列表',
      apiPath: '/b2bRequisitionOrder/list',
      countApi: '/b2bRequisitionOrder/count',
      countTransform: (data, self) => {
        let { 1: a } = data;
        setCount([undefined, a]);
      },
      // enumMainKey: 'B02_Requisition_Order_Status',
      detailLink: '/mp/purchase/requisition/detail',
      searchBarPlaceholder: '请购单号',
      tabs: ['全部', '待转订单'],
      tabConfig: [
        undefined, //全部
        1 //待转订单
      ],
      arrEnumField: [
        {
          mainKey: 'B02_Requisition_Order_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ]
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    self
  } = useList(props, config);
  const { state, dispatch } = useContext(ActionContext);
  const [isNew, setIsNew] = useState(false);

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
    //采购方, 此处必须判断系统参数是否开启了自动发送。
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, self]);

  // 新建请购
  function create(data) {
    let postbody = {
      companyCode,
      ...data,
      apiPath: '/b2bRequisitionOrder/createReqOrder'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let url = `${config.detailLink}/${companyCode}/${response.data}`;
        props.history.push(url);
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
            </div>
            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${item.reqXkNo}`}
                      key={item.id}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>{item.reqInnerNo}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass(
                                'requisition',
                                item.status
                              )
                            }
                          >
                            {item.statusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        <li>
                          <label>请购日期</label>
                          <div>{formatDate(item.reqDate)}</div>
                        </li>
                        <li>
                          <label>来源单号</label>
                          <div>{item.sourceOrderNo}</div>
                        </li>
                        {item.plantCode && (
                          <li>
                            <label>工厂</label>
                            <div>
                              {item.plantCode}, {item.plantName}
                            </div>
                          </li>
                        )}
                        <li>
                          <label>请购人</label>
                          <div>{item.reqName}</div>
                        </li>
                        <li>
                          <label>备注</label>
                          <div>{item.remark}</div>
                        </li>
                        <li>
                          <label>待采/部分/已采</label>
                          <div>
                            {item.waitPurchaseQty ? item.waitPurchaseQty : '--'}
                            /
                            {item.portionPurchaseQty
                              ? item.portionPurchaseQty
                              : '--'}
                            /{item.allPurchaseQty ? item.allPurchaseQty : '--'}
                          </div>
                        </li>
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
            {/* 新建 */}
            {User.checkAuth('10010802') && (
              <span
                className="m-create"
                onClick={() => {
                  setIsNew(true);
                }}
              >
                <i className="icon-add"></i>
              </span>
            )}
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>

      {/* 新建弹窗 */}
      <DialogEditRequisiton
        companyCode={companyCode}
        detail={{}}
        open={isNew}
        isNew={true}
        onComplete={data => {
          create(data);
        }}
        onClose={() => setIsNew(false)}
      ></DialogEditRequisiton>
    </Page>
  );
}

RequisitionList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(RequisitionList);
